import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BaseResourceService, TransparenciaTituloDescricaoQuadro } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class TransparenciaTituloDescricaoQuadroService extends BaseResourceService<TransparenciaTituloDescricaoQuadro> {

  constructor(
    protected injector: Injector
  ) {
    super(`transparencia-titulo-descricao-quadro`, injector);
  }
}
